export const categoryData = [{ id: "discount", name: "Тип цін" }];
